module.exports = __webpack_public_path__ + "img/tb_portal.b479b696.jpg";